import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import type { IPlanningSmb } from '../model/types'

import type { IApplyPlanningSmbPayload } from './types'

/**
 * Saves the SMB vs EU split. `FYear` identifies the planning cycle while `SMB` contains the
 * visible Financial Plan years and unchanged saved splits from any hidden future years.
 */
export const applyPlanningSmb = async ({
  partnerId,
  fYear,
  rows,
}: IApplyPlanningSmbPayload): Promise<IPlanningSmb[]> => {
  const response = await callProcedure<IProcedureResponse<IPlanningSmb[]>>({
    url: '/webservice/621/sp/v4/spJBPPlanningApplyChangesSMB/call',
    method: 'POST',
    data: {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.SMB': JSON.stringify(rows),
    },
  })

  if ('error' in response) {
    throw response.error
  }

  return response.data.Data ?? []
}
